( function(){
  'use strict';

  angular.module('eclipseApp.core').factory('serviceabilityService', ['$http', '$rootScope', '$q', 'uteEndpoint', function ($http, $rootScope, $q, uteEndpoint) {

    var PREV_SELECTED_OFFER_KEY = 'prev_sel_offer';

    var serviceabilityService = {
      checkServiceability: function(newAddressObj, headers){
      var headersToUse;
        if($rootScope.ruiMethods.user.is.agent() || $rootScope.isByPassed) {
          headersToUse = $.extend({}, {
            'Content-Type': 'application/x-www-form-urlencoded'
          });
        } else {
          headersToUse = $.extend({}, {
            'Content-Type': 'application/x-www-form-urlencoded'
          }, headers);
        }


        console.log($http)
        return $http({
          url: uteEndpoint('v1/addressServices'),
          method: 'POST',
          data: $.param(newAddressObj),
          headers: headersToUse

        });
      },
      clearPca: function(){
        _.each(document.querySelectorAll('.pca .pcaautocomplete.pcatext'), function (v) {
          v.style.display = 'none';
        });
        _.each(document.querySelectorAll('.pca .pcanotification'), function (v) {
          v.style.display = 'none';
        });
        _.each(document.querySelectorAll('.pca .pcaautocomplete.pcatext .pcafooter'), function (v) {
          v.style.display = 'none';
        });
      },
      cleanPrevSelectedOffer: function () {
        window.sessionStorage.removeItem(PREV_SELECTED_OFFER_KEY);
      }
    };
    return serviceabilityService;

  }]);
})();

